import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";
import { api } from "../lib/api";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const login = async (e) => {
    if (e) e.preventDefault();
    if (!email || !password) { toast.error("Enter email and password"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("mj_admin_token", data.token);
      if (data.expires_at) localStorage.setItem("mj_admin_expires_at", data.expires_at);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] grid place-items-center px-4 bg-white" data-testid="admin-login-page">
      <form onSubmit={login} className="w-full max-w-md" autoComplete="off">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-gray-400 mb-2">Admin</div>
        <h1 className="font-display font-black text-4xl tracking-tighter">Mok.Jaa Control</h1>
        <p className="text-sm text-gray-500 mt-2">Restaurant management console. Secure, weekly re-authentication.</p>

        <div className="mt-8 space-y-5">
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-gray-500">Email</label>
            <div className="flex items-center gap-2 border-b-2 border-gray-200 focus-within:border-black py-3">
              <Mail className="w-5 h-5 text-gray-400" />
              <input
                data-testid="admin-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                autoComplete="off"
                spellCheck="false"
                className="flex-1 bg-transparent outline-none text-lg"
                placeholder="you@example.com"
              />
            </div>
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-gray-500">Password</label>
            <div className="flex items-center gap-2 border-b-2 border-gray-200 focus-within:border-black py-3">
              <Lock className="w-5 h-5 text-gray-400" />
              <input
                data-testid="admin-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                autoComplete="new-password"
                className="flex-1 bg-transparent outline-none text-lg"
                placeholder="Enter your password"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-black text-white rounded-full py-4 font-bold hover:bg-gray-800 disabled:bg-gray-400 transition"
            data-testid="admin-login-btn"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
          <p className="text-xs text-gray-400 text-center leading-relaxed">
            Session expires every Monday at 00:00 UTC — weekly re-login is mandatory for security.
          </p>
        </div>
      </form>
    </div>
  );
}
